<template lang="pug">
  .component-reservation-list-filter-form.filter-form
    .entity-filters(v-if="$is('entity-filter')")
      label Status
      select(v-model="search.status", v-on:change="filterReservations").medium-5
        option(value="" selected="") All statuses
        option(value="STARTED") Started
        option(value="CONFIRMED") Confirmed
        option(value="PLANNED") Planned
        option(value="SENT") Sent
        option(value="COMPLETED") Completed
        option(value="ERROR") Error
        option(value="CANCELLED") Cancelled
    .row(v-else)
      .columns.small-1
        a.fa.fa-search.fa-2x(data-toggle="search-input select-status click-filter" v-if="$isNot('export-form')")
      .columns.toggle-input#search-input(data-toggler=".toggle-input")
        search-input-form.small-12(@filteredSearch="searchFromInput")
      .columns
        .row#select-status(data-toggler=".toggle-select")
          .columns.large-2
            selectize-vehicle(@optionSelected="vehicleSelected" :disabledSlot="0")
          .columns.large-3
            date-range-picker(@input="dateRangeSelected")
          .columns.large-2
            BookingModeSelect(v-model="search.booking_mode", :isFilter="true")
          .columns
            select(v-model="search.status")
              option(value="" selected) All Reservation Status
              option(value="STARTED") Started
              option(value="CONFIRMED") Confirmed
              option(value="PLANNED") Planned
              option(value="SENT") Sent
              option(value="COMPLETED") Completed
              option(value="ERROR") Error
              option(value="CANCELLED") Cancelled
          .columns
            select(v-model="search.billing_status")
              option(:value="null" selected) All Billing Status
              option(value="UNCHARGEABLE") Uncharchable
              option(value="MAINTENANCE") Maintenance
              option(value="ON_HOLD") On Hold
              option(value="READY") Ready
              option(value="CHARGED") Charged
          .columns
            select(v-model="search.flag")
              option(:value="null" selected) All Reservation Flags
              option(value="TERMINATED_IN_FORBIDDEN") Terminated in forbidden
              option(value="TERMINATED_IN_UNDESIRABLE") Terminated in undesirable
              option(value="HOLD_BILLING") Hold billing
              option(value="SKIP_DEPOSIT") Skip deposit
              option(value="SKIP_BILLING") Skip billing
          .columns
            select(v-model="search.order_by")
              option(selected="" disabled="") Order by
              option(value="id") Id
              option(value="start") Start
              option(value="end") End
      .columns.small-1.text-right#click-filter(data-toggler=".toggle-input" v-if="$isNot('export-form')")
        a.fa.fa-2x(:class="{'fa-sort-numeric-asc': sortAsc,'fa-sort-numeric-desc':!sortAsc}", @click="toggleDirection")
        a.fa.fa-filter.fa-2x(v-on:click="filterReservations")
</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import SearchInputForm from 'components/structure/ui/filters/SearchInputForm'
import SelectizeVehicle from '../lists/selectize/SelectizeVehicle'
import BookingModeSelect from '../../BookingModeSelect'
import DateRangePicker from '../../DateRangePicker'

export default {
  name: 'ReservationListForm',
  components: {
    BookingModeSelect,
    SelectizeVehicle,
    KeplerBackofficeSdk,
    SearchInputForm,
    DateRangePicker

  },
  data() {
    return {
      vehicleCategories: [],
      search: {
        from: null,
        to: null,
        status: null,
        billing_status: null,
        query: null,
        vehicle_slot_id: null,
        vehicle_plate: null,
        booking_mode: null,
        flag: null,
        order_by: null,
        order_direction: 'DESC',
      }
    }
  },

  created() {
    this.cleanFields()
  },
  mounted() {
    $(this.$el).foundation()
  },
  methods: {
    selectVehicle(vehicle) {
      this.search.vehicle_slot_id = vehicle.id
    },
    filterReservations() {
      this.cleanFields()
    },
    toggleDirection() {
      this.search.order_direction = this.search.order_direction === 'ASC' ? 'DESC' : 'ASC'
    },
    searchReservations(page, search) {
      this.$emit('searchReservations', search)
    },
    searchFromInput(search) {
      this.$emit('searchReservations', search)
    },
    vehicleSelected(data) {
      this.search.vehicle_slot_id = data.vehicle_slot_id
      this.search.vehicle_plate = data.plate
    },
    cleanFields() {
      var propNames = Object.getOwnPropertyNames(this.search)
      for (var i = 0; i < propNames.length; i++) {
        var propName = propNames[i]
        if (this.search[propName] === '' || this.search[propName] === null || this.search[propName] === undefined) {
          delete this.search[propName]
        }
      }
      this.$emit('filterReservations', this.search)
    },
    dateRangeSelected(range) {
      this.search.from = range.start
      this.search.to = range.end
    },

  },
  computed: {
    sortAsc() {
      return this.search.order_direction === 'ASC'
    }
  },
  props: ['type'],
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-reservation-list-filter-form
  .toggle-select
    display: none

  .toggle-input
    display: none

  #search-input > div
    margin: 0
</style>



// WEBPACK FOOTER //
// ReservationListForm.vue?52aa7b17